export default __webpack_public_path__ + "static/media/Nesha_Laser_0014_Laser_7.545694df.png";